module.exports = __webpack_public_path__ + "static/media/search-icon.eefde749.svg";